import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin:false,
    userInfo:{},
    permission:[],
    goods_class:[],
    tempid:''  //新闻详情页跳转回新闻列表页的新闻类别id
  },
  mutations: {
    isLogin(state,userInfo,permission){
      state.isLogin = true;
      state.userInfo = userInfo;
      state.permission = permission;
    },
    set_goods_class (state, goods_class) {
      state.goods_class = goods_class
    },
    set_temp_id(state, id){
      state.tempid = id
    }
  },
  actions: {
    set_goods_class ({commit}, goods_class) {
      commit('set_goods_class', goods_class)
    },
  }
})
